import {createFileRoute} from '@tanstack/react-router';

import {NewProjectPage} from '@/modules/projects/pages/NewProjectPage';

export const Route = createFileRoute('/_authenticated/projects/new')({
  component: NewProjectPage,
});
